/** Shared specialty-coverage editor types (Admin + SP). */

export type CoverageScope = 'NATIONAL' | 'REGIONAL';

export type ServiceRange = 'IN_OFFICE' | 'VIRTUAL' | 'IN_HOME';

export type SpecialtyCoverageState = {
  stateCode: string;
  allCounties: boolean;
  countyIds: string[];
};

/**
 * Editor row — round-trips with PATCH specialties[].
 * `coverageScope: null` means "not configured yet" — no inherit, no default.
 * The admin must pick a scope and at least one delivery mode before save
 * (enforced by the form schema, issue 15/24).
 */
export type SpecialtyCoverageItem = {
  specialtyId: string;
  coverageScope: CoverageScope | null;
  serviceRanges: ServiceRange[];
  coverageStates: SpecialtyCoverageState[];
  /** UI-only: already saved on provider (cascade delete needs confirm). */
  isPersisted?: boolean;
};

export type SpecialtyOption = {
  id: string;
  name: string;
  categoryId?: string | null;
};

export type SpecialtyCoveragePermissions = {
  /** Admin: true (add/remove). SP: false (coverage/ranges only). */
  canManageAttachments: boolean;
};

export type SpecialtyCoverageEditorProps = {
  value: SpecialtyCoverageItem[];
  onChange: (next: SpecialtyCoverageItem[]) => void;
  specialtyOptions: SpecialtyOption[];
  permissions: SpecialtyCoveragePermissions;
  specialtyOptionsLoading?: boolean;
  /** Server validation messages keyed by specialtyId */
  fieldErrors?: Record<string, string>;
  disabled?: boolean;
};

export const DELIVERY_MODE_META: Array<{
  value: ServiceRange;
  label: string;
}> = [
  { value: 'VIRTUAL', label: 'Virtual' },
  { value: 'IN_HOME', label: 'In home' },
  { value: 'IN_OFFICE', label: 'In office' },
];
